import * as React from 'react';
import { CoreRadioButton } from '../internal/WixUiCoreComponents/components/CoreRadioButton';
import { CoreCheckbox } from '../internal/WixUiCoreComponents/components/CoreCheckbox';
import { classes, st } from './Option.deprecated.st.css';
import { BOX_SELECTION_DATA_ATTRIBUTES, BOX_SELECTION_DATA_HOOKS, } from './dataHooks';
import classnames from 'classnames';
import { NativeSelectorConsumer } from './NativeSelector';
import { BoxSelectionSelectionType, } from './types';
/** Option */
export class Option extends React.Component {
    constructor() {
        super(...arguments);
        this.inputRef = React.createRef();
        this.state = {
            focused: false,
        };
        this._onFocus = () => {
            this.setState({ focused: true });
        };
        this._onBlur = () => {
            this.setState({ focused: false });
        };
        this._onChange = () => {
            const { id, onChange } = this.props;
            if (onChange) {
                onChange({ id });
            }
        };
        this._getAriaLabel = () => {
            const { children } = this.props;
            return this.props['aria-label']
                ? this.props['aria-label']
                : typeof children === 'string'
                    ? children
                    : null;
        };
        this._getCoreElement = (nativeSelector) => {
            const { children, id, name, checked, disabled } = this.props;
            return nativeSelector === BoxSelectionSelectionType.CHECKBOX ? (React.createElement(CoreCheckbox, { "data-hook": BOX_SELECTION_DATA_HOOKS.BOX_SELECTION_OPTION, name: name, checked: checked, value: id, onChange: this._onChange, id: id, onFocusByKeyboard: this._onFocus, onBlur: this._onBlur, disabled: disabled, "aria-describedBy": `description-${id}`, "aria-label": this._getAriaLabel(), className: classnames(classes.wrapper), ref: this.inputRef }, children)) : (React.createElement(CoreRadioButton, { "data-hook": BOX_SELECTION_DATA_HOOKS.BOX_SELECTION_OPTION, name: name, label: children, checked: checked, value: id, onChange: this._onChange, id: id, onFocusByKeyboard: this._onFocus, onBlur: this._onBlur, disabled: disabled, "aria-describedBy": `description-${id}`, "aria-label": this._getAriaLabel(), className: classnames(classes.wrapper), ref: this.inputRef }));
        };
    }
    focus() {
        var _a;
        (_a = this.inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    _getDataAttributes(nativeSelector) {
        const { checked, disabled, unavailable } = this.props;
        const { focused } = this.state;
        return {
            [BOX_SELECTION_DATA_ATTRIBUTES.CHECKED]: checked,
            [BOX_SELECTION_DATA_ATTRIBUTES.DISABLED]: disabled,
            [BOX_SELECTION_DATA_ATTRIBUTES.UNAVAILABLE]: unavailable,
            [BOX_SELECTION_DATA_ATTRIBUTES.FOCUSED]: focused,
            [BOX_SELECTION_DATA_ATTRIBUTES.NATIVE_SELECTOR]: nativeSelector,
        };
    }
    render() {
        const { id, checked, disabled, unavailable, description, size, className, vertical, } = this.props;
        const { focused } = this.state;
        return (React.createElement(NativeSelectorConsumer, null, (nativeSelector) => (React.createElement("div", Object.assign({ className: st(classes.root, {
                size,
                checked,
                disabled,
                unavailable,
            }, classnames(className, {
                [classes.focused]: focused,
                [classes.vertical]: vertical,
            })), "data-id": id, "data-hook": BOX_SELECTION_DATA_HOOKS.BOX_SELECTION_OPTION_WRAPPER }, this._getDataAttributes(nativeSelector)),
            unavailable && (React.createElement("svg", { className: classes.unavailableDiagonalLine },
                React.createElement("line", { x1: "0", y1: "100%", x2: "100%", y2: "0" }))),
            description && (React.createElement("span", { className: classes.hide, id: `description-${id}` }, description)),
            this._getCoreElement(nativeSelector)))));
    }
}
Option.defaultProps = {
    checked: false,
    disabled: false,
    unavailable: false,
};
//# sourceMappingURL=Option.js.map